import * as React from 'react'
import { Image, logoLoadingRect } from 'Components/view-image'
import style from './index.module.scss'
import { ITag } from 'New/used-car/detail/services/getSimilarCarDetail'
import Cookies from '@arsenal/arsenal/modules/Cookies'

interface IProps {
  src?: string
  isVideo?: boolean
  recall_type?: number
  seriesId?: number
  sku_id?: number
  title?: string
  sub_title?: string
  cityName?: string
  tips?: ITag[]
  price?: string
  office_price?: string
  pv_text?: string
  sh_city_name?: string
  transfer_cnt?: number
  onClick?(): void
}

const UsedcarCard: React.FC<IProps> = ({
  src,
  isVideo,
  recall_type = 1,
  seriesId,
  sku_id,
  title,
  sub_title,
  cityName,
  tips,
  price,
  office_price,
  pv_text,
  sh_city_name,
  transfer_cnt = -1,
  onClick,
}) => {
  const tag_text =
    recall_type === 2
      ? '相似车源'
      : [4, 5, 6, 7].includes(recall_type)
      ? '同品牌车源'
      : ''
  return (
    <React.Fragment>
      <a
        className={`tw-block tw-w-full tw-font-PingFangSC hover:tw-shadow-md ${style.card} `}
        href={`/usedcar/${sku_id}`}
        target="_blank"
        onClick={() => {
          if (!sh_city_name) return
          Cookies({ rit_city: sh_city_name })
        }}
      >
        <div className={`tw-relative`}>
          <Image
            src={src || ''}
            width={300}
            height={200}
            alt={`二手${title}`}
            hoverTransition={true}
            autoPixelRatio={true}
            layout={'responsive'}
            errorImg={logoLoadingRect}
            cusDefaultImg={logoLoadingRect}
            className="tw-rounded-t-2"
          />
          {isVideo ? (
            <i
              className={`DCD_Icon icon_play_2 tw-text-40 xl:tw-text-60 tw-text-white tw-pointer-events-none`}
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translateX(-50%) translateY(-50%)',
              }}
            />
          ) : null}
          {tag_text && (
            <div
              className={`tw-absolute tw-flex tw-justify-end tw-w-full tw-h-80 ${style['card-top']}  tw-text-14 tw-text-white`}
            >
              <div
                className={`${style['tag-box']} ${
                  recall_type === 2 ? 'tw-w-102' : 'tw-w-114'
                }`}
              >
                <div
                  className={` ${style.tag} tw-absolute ${
                    recall_type === 2 ? 'tw-w-102' : 'tw-w-114'
                  }`}
                />
                <p className={`tw-absolute tw-w-auto tw-h-auto tw-right-2`}>
                  {tag_text}
                  <i className={`DCD_Icon icon_into_12 tw-text-14`} />
                </p>
              </div>
            </div>
          )}
          {pv_text && (
            <div
              className={`tw-absolute tw-flex  tw-w-full tw-h-80 ${style['card-bottom']}  tw-text-12 tw-text-white tw-px-8 tw-py-4`}
            >
              <div className="tw-flex tw-items-center">
                <i className={`DCD_Icon icon_my_follow_24`} />
                {pv_text}
              </div>
            </div>
          )}
        </div>
        <dl className={`tw-bg-white tw-p-12 tw-rounded-b-2 tw-h-146`}>
          <dt
            className={`tw-font-semibold tw-text-18 tw-leading-24 xl:tw-text-18 xl:tw-leading-28`}
          >
            <p title={title} className="line-1">
              {title}
            </p>
          </dt>
          <dd
            className={`tw-mt-4 tw-text-color-gray-800 tw-text-12 tw-leading-18 xl:tw-text-14 xl:tw-leading-28 font-pORE5nVm2QTpLQtk font-G28BNCvDx6IvixLE`}
          >
            {sub_title}
            {cityName ? ` | ${cityName}` : ''}
          </dd>
          <dd
            className={`tw-mt-4 tw-flex tw-flex-wrap tw-justify-left tw-items-center tw-text-12 tw-leading-16 xl:tw-leading-18 tw-h-20 xl:tw-h-22 tw-overflow-hidden`}
          >
            {tips?.slice(0, 3)?.map((tip, index) => {
              return (
                <span
                  key={index}
                  className={`tw-flex tw-items-center tw-px-4 tw-py-2 tw-mr-6 tw-text-12 tw-leading-16 xl:tw-leading-18  tw-rounded-2 tw-bg-opacity-10 tw-whitespace-nowrap font-pORE5nVm2QTpLQtk font-G28BNCvDx6IvixLE`}
                  style={{
                    color: tip?.text_color,
                    backgroundColor: tip?.background_color,
                  }}
                >
                  {!!tip?.logo && (
                    <img src={tip?.logo} className={`tw-w-12 tw-mr-3`} />
                  )}
                  {tip?.text}
                </span>
              )
            })}
            {(tips?.length || 0) < 3 && transfer_cnt >= 0 && (
              <span
                className={`tw-flex tw-items-center tw-px-4 tw-py-2 tw-mr-6 tw-text-12 tw-leading-16 xl:tw-leading-18  tw-rounded-2 tw-bg-opacity-10 tw-whitespace-nowrap font-pORE5nVm2QTpLQtk font-G28BNCvDx6IvixLE`}
                style={{
                  color: 'rgb(31,33,41)',
                  backgroundColor: 'rgb(242,244,250)',
                }}
              >
                {`过户${transfer_cnt || 0}次`}
              </span>
            )}
          </dd>
          <dd
            className={`tw-mt-12 tw-font-bold tw-text-18 tw-leading-28 xl:tw-text-20 xl:tw-leading-32 tw-text-color-red-500 font-pORE5nVm2QTpLQtk font-G28BNCvDx6IvixLE`}
          >
            {`${price}`}
            <span className="tw-ml-4 tw-font-normal tw-text-12 tw-leading-18 xl:tw-text-14 xl:tw-leading-20 tw-text-color-gray-800 font-pORE5nVm2QTpLQtk font-G28BNCvDx6IvixLE">
              {`新车指导价: ${office_price}`}
            </span>
          </dd>
        </dl>
      </a>
    </React.Fragment>
  )
}

export default UsedcarCard
